import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faHeadset, faQuestion } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Footer() {
    return (
        <div
            id="kt_footer"
            className="footer bg-white py-4 d-flex flex-lg-column"
        >
            <div className="container d-flex flex-column flex-md-row align-items-center justify-content-between">
                <div className="text-dark order-2 order-md-1">
                    <span className="text-muted font-weight-bold mr-2">
                        {new Date().getFullYear()}©
                    </span>
                    <a
                        href="http://www.capys.com.br"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-dark-75 text-hover-primary"
                    >
                        CAPYS CRM - O CRM mais Completo do Mercado Imobiliário!
                    </a>
                </div>
                <div className="d-flex order-1">
                    <div className="nav nav-dark order-1 order-md-2 mr-4">
                        <a
                            href="https://api.whatsapp.com/send?phone=553131810970&text=Ol%C3%A1%2C%20gostaria%20de%20falar%20com%20um%20atendente."
                            target="_blank"
                            rel="noopener noreferrer"
                            className="nav-link pl-3 pr-0"
                        >
                            <FontAwesomeIcon
                                icon={faWhatsapp}
                                className="mr-2"
                            />{" "}
                            Atendimento por WhatsApp
                        </a>
                    </div>
                    <div className="nav nav-dark order-1 order-md-2 mr-4">
                        <a
                            href="https://atendimento.capys.com.br/login.html"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="nav-link pl-3 pr-0"
                        >
                            <FontAwesomeIcon
                                icon={faHeadset}
                                className="mr-2"
                            />{" "}
                            Portal de Atendimentos CAPYS
                        </a>
                    </div>
                    <div className="nav nav-dark order-1 order-md-2">
                        <a
                            href="http://ajuda.capys.com.br/pt-BR/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="nav-link pl-3 pr-0"
                        >
                            <FontAwesomeIcon
                                icon={faQuestion}
                                className="mr-2"
                            />{" "}
                            Central de Ajuda CAPYS
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
